import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Juan', 'Carlos', 'Ana', 'Luis', 'Sofía', 'Diego', 'Valentina', 'Miguel', 'Camila', 'Lucía', 'Mateo', 'Isabella', 'Santiago', 'Martina'];
const CITIES = ['Buenos Aires', 'Ciudad de México', 'Bogotá', 'Lima', 'Santiago', 'Montevideo', 'Quito', 'Asunción', 'Caracas', 'San José', 'Medellín', 'Córdoba', 'Guadalajara', 'Rosario', 'Cali'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 5000);
    const triggerNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      // Schedule next notification (random between 8-15 seconds)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(triggerNotification, nextDelay + 5000); // Add display time to delay
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-126">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:bottom-4 z-50 max-w-sm bg-white rounded-lg shadow-lg border border-teal-100 p-4 flex items-center gap-3" data-id="element-127">
          <div className="bg-teal-100 p-2 rounded-full flex-shrink-0" data-id="element-128">
            <CheckCircle2 className="w-5 h-5 text-teal-600" data-id="element-129" />
          </div>
          <div data-id="element-130">
            <p className="text-sm font-medium text-gray-900" data-id="element-131">
              {notification.name} de {notification.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-132">
              acaba de comprar la plantilla
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}